import React, { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";

const fallbackOptions = [{ label: "Unknown", value: "Unknown" }];

function CountryDropdown({
  value = "",
  label = "Country",
  error = "",
  width = "100%",
  onChange,
}) {
  const [options, setOptions] = useState(fallbackOptions);

  useEffect(() => {
    let isMounted = true;

    fetch("/countries.json")
      .then((response) => response.json())
      .then((countries) => {
        if (isMounted) {
            console.log("c",countries)
          setOptions([...fallbackOptions, ...countries]);
        }
      })
      .catch(() => {});

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div style={{ width, display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "0.4rem" }}>
      <label className="font-bold">
        {label}
      </label>
      <div style={{ width: "100%" }}>
        <Dropdown
          value={value}
          options={options}
          optionLabel="label"
          optionValue="value"
          placeholder="Select a country"
          className={error ? "p-invalid" : ""}
          style={{ width: "100%" }}
          onChange={(event) => onChange(event.value)}
        />
        {error && <small className="p-error">{error}</small>}
      </div>
    </div>
  );
}

export default CountryDropdown;
